<div class="register-layout">
  <div class="row form-layout py-4">
    <div class="col-md-10 form position-relative">
      <div class="mt-1">
        <div class="form-label ">
          <h2 class="dashboard-sub-heading">Master Account</h2>
        </div>

        <hr>

        <div class="row">
          <form class="row g-3" [formGroup]="masterAccForm" novalidate>
            <div class="col-md-6 text-start">
              <label for="masterAccLastName" class="form-label">Name</label>
              <input type="text" class="form-control" id="masterAccLastName" ng-required="expression"
                     formControlName="masterAccLastName"

                     [ngClass]="{ 'is-invalid': createMasterAccClicked && formInstControl['masterAccLastName'].errors }"
              >
              <div *ngIf="createMasterAccClicked && formInstControl['masterAccLastName'].errors"
                   class="invalid-feedback">
                <div *ngIf="formInstControl['masterAccLastName'].errors['required']">
                  Name is required
                </div>
              </div>
            </div>
            <!-- <div class="col-md-6 text-start">
                <label for="masterAccOtherName" class="form-label">Other Name</label>
                <input type="text" class="form-control" id="masterAccOtherName"
                    formControlName="masterAccOtherName"
                    [ngClass]="{ 'is-invalid': createMasterAccClicked && formInstControl['masterAccOtherName'].errors }">
                <div *ngIf="createMasterAccClicked && formInstControl['masterAccOtherName'].errors"
                    class="invalid-feedback">
                    <div *ngIf="formInstControl['masterAccOtherName'].errors['required']">
                        Other Name is required
                    </div>
                </div>
            </div> -->
            <!-- <div class="col-md-6 text-start">
                <label for="masterAccPassportNumber" class="form-label">Passport Number</label>
                <input type="text" class="form-control" id="masterAccPassportNumber"
                    formControlName="masterAccPassportNumber"
                    [ngClass]="{ 'is-invalid': createMasterAccClicked && formInstControl['masterAccPassportNumber'].errors }">
                <div *ngIf="createMasterAccClicked && formInstControl['masterAccPassportNumber'].errors"
                    class="invalid-feedback">
                    <div *ngIf="formInstControl['masterAccPassportNumber'].errors['required']">
                        Passport Number is required
                    </div>
                </div>
            </div>
            <div class="col-md-6 text-start">
                <label for="masterAccGender" class="form-label">Gender</label>
                <div class="d-flex mt-1">
                    <div class="form-check">
                        <input mdbRadio class="form-check-input" type="radio" name="flexRadioDefault"
                            id="flexRadioDefault1" />
                        <label class="form-check-label" for="flexRadioDefault1"> Male </label>
                    </div>
                    <div class="form-check ms-4">
                        <input mdbRadio class="form-check-input" type="radio" name="flexRadioDefault"
                            id="flexRadioDefault2" />
                        <label class="form-check-label" for="flexRadioDefault2">Female </label>
                    </div>
                </div>
                <div *ngIf="createMasterAccClicked && formInstControl['masterAccGender'].errors"
                    class="invalid-feedback">
                    <div *ngIf="formInstControl['masterAccGender'].errors['required']">
                        Bank Account Number is required
                    </div>
                </div>
            </div> -->
            <!-- <div class="col-md-6 text-start">
                <label for="masterAccBirthDay" class="form-label">Birth Day</label>
                <input type="text" class="form-control" id="masterAccBirthDay"
                    formControlName="masterAccBirthDay"
                    [ngClass]="{ 'is-invalid': createMasterAccClicked && formInstControl['masterAccBirthDay'].errors }">
                <div *ngIf="createMasterAccClicked && formInstControl['masterAccBirthDay'].errors"
                    class="invalid-feedback">
                    <div *ngIf="formInstControl['masterAccBirthDay'].errors['required']">
                        Birth Day is required
                    </div>
                </div>
            </div> -->
            <!-- <div class="col-md-6 text-start">
                <label for="masterAccContactNoHome" class="form-label">Contact Number(Home)</label>
                <ngx-intl-tel-input class="form-control" id="masterAccContactNoHome"
                    formControlName="masterAccContactNoHome"
                    [ngClass]="{ 'is-invalid': createMasterAccClicked && formInstControl['masterAccContactNoHome'].errors }"
                    [cssClass]="'custom'" [enablePlaceholder]="false" [searchCountryFlag]="false"
                    [separateDialCode]="false" [selectFirstCountry]="false" [customPlaceholder]="''"
                    [maxLength]="15" [phoneValidation]="false"></ngx-intl-tel-input>

                <div *ngIf="createMasterAccClicked && formInstControl['masterAccContactNoHome'].errors" class="invalid-feedback">
                    <div *ngIf="formInstControl['masterAccContactNoHome'].errors['required']">
                        Contact Number is required
                    </div>
                    </div>
            </div> -->
            <!-- <div class="col-md-6 text-start">
                <label for="masterAccContactNoOffice" class="form-label">Contact Number(Office)</label>
                <ngx-intl-tel-input class="form-control" id="masterAccContactNoOffice"
                    formControlName="masterAccContactNoOffice"
                    [ngClass]="{ 'is-invalid': createMasterAccClicked && formInstControl['masterAccContactNoOffice'].errors }"
                    [cssClass]="'custom'" [enablePlaceholder]="true" [searchCountryFlag]="false"
                    [separateDialCode]="false" [selectFirstCountry]="false" [customPlaceholder]="''"
                    [maxLength]="15" [phoneValidation]="false"></ngx-intl-tel-input>

                <div *ngIf="createMasterAccClicked && formInstControl['masterAccContactNoOffice'].errors" class="invalid-feedback">
                    <div *ngIf="formInstControl['masterAccContactNoOffice'].errors['required']">
                        Contact Number is required
                    </div>
                    </div>
            </div> -->
            <div class="col-md-6 text-start">
              <label for="contactNo" class="form-label">Contact Number</label>
              <div class=" row d-flex">
                <div class="col-md-3"><ngx-intl-tel-input
                  style="width: 2vw"
                  type="text"
                  id="contactNo"
                  formControlName="masterAccContactNoMobile"
                  [enablePlaceholder]="true"
                  [searchCountryFlag]="true"
                  [selectFirstCountry]="true"
                  [separateDialCode]="true"
                  [maxLength]="0"
                  [outerText]=""
                  [phoneValidation]="false"

                  [enableAutoCountrySelect]="true"
                ></ngx-intl-tel-input></div>

                <div class=" col-md-9 sl-flex-row" id="contactNum">
                  <!--              <input type="text" class="form-control" id="contactNoLoad" formControlName="contactNo"-->
                  <!--                     [ngClass]="{ 'is-invalid': submitted && formControl['contactNo'].errors }"-->
                  <!--                     [readonly]="role == 'admin'" [hidden]="role != 'admin'">-->
                  <input
                    placeholder="1234567"
                    type="number"
                    class="form-control"
                    formControlName="contactNumber"
                  />
                  <div class="invalid-feedback">
                    <div>&nbsp;&nbsp;Contact Number is required</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 text-start">
              <label for="masterAccEmail" class="form-label">Email address</label>
              <input type="text" class="form-control" id="masterAccEmail" formControlName="masterAccEmail"
                     [ngClass]="{
                                'is-invalid':
                                createMasterAccClicked &&
                                  formInstControl['masterAccEmail'].errors
                              }" />
              <div *ngIf="
                            createMasterAccClicked && formInstControl['masterAccEmail'].errors
                              " class="invalid-feedback">
                <div *ngIf="formInstControl['masterAccEmail'].errors['required']">
                  Email is required
                </div>
                <div *ngIf="formInstControl['masterAccEmail'].errors['email']">
                  Email is not valid
                </div>
              </div>
            </div>
            <div class="col-md-6 text-start">
              <label for="masterAccProfession" class="form-label">Profession</label>
              <input  type="text" class="form-control" id="masterAccProfession"
                      formControlName="masterAccProfession"
                      [ngClass]="{ 'is-invalid': createMasterAccClicked && formInstControl['masterAccProfession'].errors }">
              <div *ngIf="createMasterAccClicked && formInstControl['masterAccProfession'].errors"
                   class="invalid-feedback">
                <div *ngIf="formInstControl['masterAccProfession'].errors['required']">
                  Profession is required
                </div>
              </div>
            </div>
            <!-- <div class="col-md-6 text-start">
                <label for="masterAccAddress1" class="form-label">Address 1</label>
                <input type="text" class="form-control" id="masterAccAddress1"
                    formControlName="masterAccAddress1"
                    [ngClass]="{ 'is-invalid': createMasterAccClicked && formInstControl['masterAccAddress1'].errors }">
                <div *ngIf="createMasterAccClicked && formInstControl['masterAccAddress1'].errors"
                    class="invalid-feedback">
                    <div *ngIf="formInstControl['masterAccAddress1'].errors['required']">
                        Address 1 is required
                    </div>
                </div>
            </div>
            <div class="col-md-6 text-start">
                <label for="masterAccAddress2" class="form-label">Address 2</label>
                <input type="text" class="form-control" id="masterAccAddress2"
                    formControlName="masterAccAddress2"
                    [ngClass]="{ 'is-invalid': createMasterAccClicked && formInstControl['masterAccAddress2'].errors }">
                <div *ngIf="createMasterAccClicked && formInstControl['masterAccAddress2'].errors"
                    class="invalid-feedback">
                    <div *ngIf="formInstControl['masterAccAddress2'].errors['required']">
                        Address 2 is required
                    </div>
                </div>
            </div>
            <div class="col-md-6 text-start">
                <label for="masterAccCity" class="form-label">City</label>
                <input type="text" class="form-control" id="masterAccCity"
                    formControlName="masterAccCity"
                    [ngClass]="{ 'is-invalid': createMasterAccClicked && formInstControl['masterAccCity'].errors }">
                <div *ngIf="createMasterAccClicked && formInstControl['masterAccCity'].errors"
                    class="invalid-feedback">
                    <div *ngIf="formInstControl['masterAccCity'].errors['required']">
                        City is required
                    </div>
                </div>
            </div> -->
            <div class="col-md-6 text-start">
              <label for="masterAccCountryID" class="form-label">Country</label>
              <select  class="form-select" aria-label="Default select example"
                       formControlName="masterAccCountryID"
                       [ngClass]="{'is-invalid': createMasterAccClicked && formInstControl['masterAccCountryID'].errors}">
                <option [ngValue]="country.countryId" *ngFor="let country of countries">
                  {{ country.countryName }}
                </option>
              </select>
              <div *ngIf="createMasterAccClicked && formInstControl['masterAccCountryID'].errors"
                   class="invalid-feedback">
                <div *ngIf="formInstControl['masterAccCountryID'].errors['required']">
                  Select a Country
                </div>
              </div>
            </div>
            <!-- <div class="col-md-6 text-start">
                <label for="masterAccNationalIdNumber" class="form-label">National ID Number</label>
                <input type="text" class="form-control" id="masterAccNationalIdNumber"
                    formControlName="masterAccNationalIdNumber"
                    [ngClass]="{ 'is-invalid': createMasterAccClicked && formInstControl['masterAccNationalIdNumber'].errors }">
                <div *ngIf="createMasterAccClicked && formInstControl['masterAccNationalIdNumber'].errors"
                    class="invalid-feedback">
                    <div *ngIf="formInstControl['masterAccNationalIdNumber'].errors['required']">
                        National ID Name is required
                    </div>
                </div>
            </div> -->
            <div class="col-md-6 text-start">
              <label for="masterAccNationality" class="form-label">Nationality</label>
              <input   type="text" class="form-control" id="masterAccNationality"
                       formControlName="masterAccNationality"
                       [ngClass]="{ 'is-invalid': createMasterAccClicked && formInstControl['masterAccNationality'].errors }">
              <div *ngIf="createMasterAccClicked && formInstControl['masterAccNationality'].errors"
                   class="invalid-feedback">
                <div *ngIf="formInstControl['masterAccNationality'].errors['required']">
                  Nationality is required
                </div>
              </div>
            </div>
            <!-- <div class="col-md-6 text-start">
                <label for="masterAccNationalID" class="form-label">National ID </label>
                <input type="text" class="form-control" id="masterAccNationalID"
                    formControlName="masterAccNationalID"
                    [ngClass]="{ 'is-invalid': createMasterAccClicked && formInstControl['masterAccNationalID'].errors }">
                <div *ngIf="createMasterAccClicked && formInstControl['masterAccNationalID'].errors"
                    class="invalid-feedback">
                    <div *ngIf="formInstControl['masterAccNationalID'].errors['required']">
                        National ID  is required
                    </div>
                </div>
            </div>
            <div class="col-md-6 text-start">
                <label for="masterAccDrivingLicenceNo" class="form-label">Driving Licence Number </label>
                <input type="text" class="form-control" id="masterAccDrivingLicenceNo"
                    formControlName="masterAccDrivingLicenceNo"
                    [ngClass]="{ 'is-invalid': createMasterAccClicked && formInstControl['masterAccDrivingLicenceNo'].errors }">
                <div *ngIf="createMasterAccClicked && formInstControl['masterAccDrivingLicenceNo'].errors"
                    class="invalid-feedback">
                    <div *ngIf="formInstControl['masterAccDrivingLicenceNo'].errors['required']">
                        National ID  is required
                    </div>
                </div>
            </div>
            <div class="col-md-6 text-start">
                <label for="masterAccPrimaryInvestorNo" class="form-label">Primary Investor Number</label>
                <input type="text" class="form-control" id="masterAccPrimaryInvestorNo"
                    formControlName="masterAccPrimaryInvestorNo"
                    [ngClass]="{ 'is-invalid': createMasterAccClicked && formInstControl['masterAccPrimaryInvestorNo'].errors }">
                <div *ngIf="createMasterAccClicked && formInstControl['masterAccPrimaryInvestorNo'].errors"
                    class="invalid-feedback">
                    <div *ngIf="formInstControl['masterAccPrimaryInvestorNo'].errors['required']">
                        National ID  is required
                    </div>
                </div>
            </div>
            <div class="col-md-6 text-start">
                <label for="masterAccRegistrationNo" class="form-label">Registration Number</label>
                <input type="text" class="form-control" id="masterAccRegistrationNo"
                    formControlName="masterAccRegistrationNo"
                    [ngClass]="{ 'is-invalid': createMasterAccClicked && formInstControl['masterAccRegistrationNo'].errors }">
                <div *ngIf="createMasterAccClicked && formInstControl['masterAccRegistrationNo'].errors"
                    class="invalid-feedback">
                    <div *ngIf="formInstControl['masterAccRegistrationNo'].errors['required']">
                        National ID  is required
                    </div>
                </div>
            </div>
            <div class="col-md-6 text-start">
                <label for="masterAccExternalRefNo" class="form-label">External Reference Number</label>
                <input type="text" class="form-control" id="masterAccExternalRefNo"
                    formControlName="masterAccExternalRefNo"
                    [ngClass]="{ 'is-invalid': createMasterAccClicked && formInstControl['masterAccExternalRefNo'].errors }">
                <div *ngIf="createMasterAccClicked && formInstControl['masterAccExternalRefNo'].errors"
                    class="invalid-feedback">
                    <div *ngIf="formInstControl['masterAccExternalRefNo'].errors['required']">
                        National ID  is required
                    </div>
                </div>
            </div> -->
          </form>
        </div>

        <div class="d-flex" style="justify-content:flex-end;">
          <div class="">
            <div class="p-2">
              <button [disabled]="masterAccountCreated" type="button" class="btn btn-primary mt-4" type="submit"
                      (click)="createMasterAccount()">
                <div *ngIf="loading" class="spinner-border spinner-border-sm text-light" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <p *ngIf="!loading">
                  Create
                </p>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="initialLoading" class="position-absolute top-50 start-50 translate-middle">
        <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</div>
<app-master-accounts></app-master-accounts>
